<template>
  <transition
    name="fade"
    mode="out-in">
    <div
      v-if="show"
      class="modal-popup"
      @click.stop="closePopup($event)">
      <img
        :src="imgSrc"
        alt="预览">
    </div>
    <div
      v-if="showWaterMark"
      class="modal-popup"
      @click.stop="closePopup($event)">
      <img
        style="background: rgba(0,0,0,.4)"
        :src="imgSrc"
        alt="预览">
    </div>
  </transition>
</template>

<script>
export default {
  data () {
    return {
      imgSrc: '',
      show: false,
      showWaterMark:false
    }
  },

  created () {
    this.$root.eventHub.$on('showPre', img => {
      if (img) {
        this.show = true
        this.imgSrc = img
      }
    })
    this.$root.eventHub.$on('showWaterMark', img => {
      if (img) {
        this.showWaterMark = true
        this.imgSrc = img
      }
    })
  },

  methods: {
    closePopup (e) {
      let target = e.target
      let isImg = target.nodeName.toLowerCase() === 'img'
      if (!isImg) {
        this.show = false
        this.showWaterMark = false
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.modal-popup
  position absolute
  top 0 
  right 0 
  bottom 0
  left 0
  z-index 9999
  background-color rgba(0,0,0,.16)
  > img 
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)
    max-height 70%

</style>
